import { Grid, Card, Typography, Box } from "@mui/material";

type HeatStatusKey = keyof typeof heatStatuses;
interface Props {
  aditionalLabel?: string | number | null;
  heatStatus?: HeatStatusKey | null;
}

type HeatStatus = {
  name: string;
  color: string;
  letter: string;
};

const heatStatuses: { [key: string]: HeatStatus } = {
  S: { name: "Scheduled", color: "#0288D1", letter: "S" },
  M: { name: "Melting", color: "#FF7043", letter: "M" },
  T: { name: "Tapped", color: "#FFD600", letter: "T" },
  L: { name: "In LMF", color: "#00610E", letter: "L" },
  U: { name: "Ready To Cast", color: "#FFC107", letter: "U" },
  C: { name: "In Caster", color: "#FF5722", letter: "C" },
  O: { name: "Opened", color: "#43A047", letter: "O" },
  P: { name: "Closed", color: "#607D8B", letter: "P" },
  F: { name: "Finished", color: "#3F51B5", letter: "F" },
};

export const StatusTitle = ({ aditionalLabel, heatStatus }: Props) => {
  const defaultColor = "#D6D6D6";
  const value =
    heatStatus !== undefined
      ? heatStatus
        ? heatStatuses[heatStatus]
        : null
      : undefined;

  return (
    <>
      {aditionalLabel && (
        <Card
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            userSelect: "none",
            height: "40px",
            backgroundColor: "#dae8fc",
          }}
          variant="outlined"
        >
          <Typography>{aditionalLabel}</Typography>
        </Card>
      )}

      {heatStatus !== undefined && (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {value ? (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "4px",
                      minWidth: "24px",
                      height: "24px",
                      backgroundColor: value.color || defaultColor,
                      color:
                        heatStatus === "U" || heatStatus === "T"
                          ? "#000"
                          : "#fff",
                    }}
                  >
                    <Typography variant="body2">{value.letter}</Typography>
                  </Box>
                  <Typography>{value.name}</Typography>
                </>
              ) : (
                <Typography sx={{ color: "red" }}>Unlinked</Typography>
              )}
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};
